'use client';

import { useEffect, useState } from 'react';

type UsePulsingCirclesParams = {
  delay?: number;
};

export const usePulsingCircles = ({ delay = 2000 }: UsePulsingCirclesParams = {}) => {
  const [showCircles, setShowCircles] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowCircles(true);
    }, delay);

    return () => clearTimeout(timeout);
  }, [delay]);

  return { showCircles };
};
